import { gql } from "lib/apolloClient";
import { fragments, calendarEventTagFragment } from "./CalendarFragment";

export const getCalendarEventsQuery = gql`
  query getCalendarEvents(
    $rangeBeginStartDate: String!
    $rangeEndStartDate: String!
    $filters: CalendarEventFilter
  ) {
    school {
      calendarEvents(
        rangeBeginStartDate: $rangeBeginStartDate
        rangeEndStartDate: $rangeEndStartDate
        filters: $filters
      ) {
        ...calendarEvent
      }
    }
  }
  ${fragments.calendarEvent}
`;

export const getHolidayExceptionsQuery = gql`
  query getHolidayExceptions(
    $rangeBeginStartDate: String!
    $rangeEndStartDate: String!
    $filters: CalendarEventFilter
  ) {
    school {
      calendarEvents(
        rangeBeginStartDate: $rangeBeginStartDate
        rangeEndStartDate: $rangeEndStartDate
        filters: $filters
      ) {
        ...calendarEvent
      }
    }
  }
  ${fragments.calendarEvent}
`;

export const getCalendarEventTagsQuery = gql`
  query getCalendarEventTags($id: ID!) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        calendarEventTags {
          ...calendarEventTagItem
        }
      }
    }
  }
  ${calendarEventTagFragment.calendarEventTag}
`;

export const getOrganizationRotationDaysQuery = gql`
  query getOrganizationRotationDays($id: ID!, $filters: RotationDayInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        rotationDays(filters: $filters) {
          ...rotationDayItem
        }
      }
    }
  }
  ${fragments.rotationDay}
`;
